// extracted by mini-css-extract-plugin
export default {"container":"RunningBlock_container__5Zeug","mainPath":"RunningBlock_mainPath__87dC8","maskRect":"RunningBlock_maskRect__UQlwq","active":"RunningBlock_active__-TZc-"};